import type { DialPadTarget } from '../types';

/**
 * Возвращает заголовок подсказки для DialPad:
 * приоритет у displayName, иначе берётся user-часть SIP AoR.
 *
 * @param target Цель звонка, которую нужно отрисовать в списке подсказок.
 * @returns Текст заголовка для элемента списка.
 */
export const getDialPadSuggestionTitle = (target: DialPadTarget) => {
	if (target.displayName) return target.displayName;
	const withoutScheme = target.aor.replace(/^sip:/i, '');
	return withoutScheme.split('@')[0] || target.aor;
};
